import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Alert,
  Box,
  Typography,
} from '@mui/material';
import { updateDrinkRequestStatus } from '../../../../../services/Admin/NamedDrinksRequestApi';

const ChangeAiDrinkStatueDialog = ({ open, onClose, request, onSuccess }) => {
  const [status, setStatus] = useState(request?.status || 'pending');
  const [notes, setNotes] = useState(request?.notes || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleNotesChange = (event) => {
    setNotes(event.target.value);
  };

  const handleSubmit = async () => {
    if (!status) {
      setError('يرجى تحديد الحالة');
      return;
    }

    setLoading(true);
    setError('');
    try {
      await updateDrinkRequestStatus(request?.id, status, notes);
      
      // نجاح العملية
      onSuccess?.();
      handleClose();
    } catch (err) {
      console.error('خطأ في تحديث الحالة:', err);
      setError(err.message || 'حدث خطأ في تحديث الحالة');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setStatus(request?.status || 'pending');
    setNotes(request?.notes || '');
    setError('');
    onClose?.();
  };

  const getStatusColor = (stat) => {
    switch (stat) {
      case 'pending':
        return 'warning';
      case 'approved':
        return 'success';
      case 'rejected':
        return 'error';
      default:
        return 'default';
    }
  };

  const getStatusLabel = (stat) => {
    switch (stat) {
      case 'pending':
        return 'قيد الانتظار';
      case 'approved':
        return 'موافق عليه';
      case 'rejected':
        return 'مرفوض';
      default:
        return stat;
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth dir="rtl">
      <DialogTitle sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
        تعديل حالة طلب المشروب
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {/* معلومات الطلب */}
        <Box sx={{ mb: 3, p: 2, backgroundColor: '#f9f9f9', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <strong>اسم المشروب:</strong> {request?.drink_name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>المستخدم:</strong> {request?.user?.name}
          </Typography>
        </Box>

        {/* تحديد الحالة */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>الحالة</InputLabel>
          <Select
            value={status}
            label="الحالة"
            onChange={handleStatusChange}
            disabled={loading}
          >
            <MenuItem value="pending">⏳ قيد الانتظار</MenuItem>
            <MenuItem value="approved">✅ موافق عليه</MenuItem>
            <MenuItem value="rejected">❌ مرفوض</MenuItem>
          </Select>
        </FormControl>

        {/* حقل الملاحظات */}
        <TextField
          fullWidth
          multiline
          rows={4}
          label="ملاحظات"
          placeholder="أضف ملاحظات حول هذا الطلب..."
          value={notes}
          onChange={handleNotesChange}
          disabled={loading}
          dir="rtl"
          sx={{ mb: 2 }}
        />

        {/* معاينة الحالة الجديدة */}
        <Box sx={{ p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
          <Typography variant="caption" color="text.secondary">
            الحالة الجديدة:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'bold', color: `${getStatusColor(status)}.main` }}>
            {getStatusLabel(status)}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} disabled={loading}>
          إلغاء
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ minWidth: 100 }}
        >
          {loading ? <CircularProgress size={24} /> : 'تحديث'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeAiDrinkStatueDialog;
